export default "__VITE_ASSET__44bd9b47__"